export default __webpack_public_path__ + "static/media/Gmail1.6585009d.jpg";